"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./~/antd/~/rc-table/lib/Column.js
// module id = 702
// module chunks = 0